import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import CaseStudies from './components/CaseStudies';
import Philosophy from './components/Philosophy';
import TechStack from './components/TechStack';
import Pricing from './components/Pricing';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-black text-zinc-100 font-sans selection:bg-cyan-900 selection:text-cyan-50">
      <Navbar />
      <main>
        <Hero />
        <Capabilities />
        <CaseStudies />
        <Philosophy />
        <TechStack />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;